/**
 * DEDICATED PRODUCT CARD QUICK ADD HANDLER
 * Completely isolated add to cart functionality for product cards only
 * Always adds exactly 1 item, no exceptions
 */

(function() {
  'use strict';

  // Unique initialization guard
  if (window.__productCardQuickAddInit) {
    return;
  }
  window.__productCardQuickAddInit = true;

  // Track active requests to prevent duplicates
  const activeRequests = new Set();

  /**
   * Add single item to cart - always quantity 1
   */
  async function addSingleItemToCart(variantId, button) {
    // Check if this variant is already being added
    if (activeRequests.has(variantId)) {
      return;
    }

    // Mark as active
    activeRequests.add(variantId);

    try {
      // Store original button state
      const originalHTML = button.innerHTML;
      const originalDisabled = button.disabled;

      // Set loading state
      button.disabled = true;
      button.classList.add('loading');
      button.innerHTML = '<div class="loader-spinner-btn"></div>';

      // Trigger theme loading
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      // Create request - HARDCODED quantity 1
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      // Make request
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || errorData.message || 'Failed to add item');
      }

      const data = await response.json();

      // Verify cart state
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      // Open cart drawer
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        // Refresh cart drawer
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        // Wait for refresh then open
        setTimeout(() => {
          if (typeof drawer.show === 'function') {
            drawer.show();
          } else {
            drawer.classList.add('is-open');
            drawer.setAttribute('open', 'true');
          }
        }, 300);
      }

      // Update header cart count
      document.querySelectorAll('cart-count').forEach(el => {
        el.innerText = cart.item_count;
      });

      document.querySelectorAll('cart-dot').forEach(el => {
        el.classList.toggle('is-visible', cart.item_count > 0);
      });

      // Restore button state
      button.disabled = originalDisabled;
      button.classList.remove('loading');
      button.innerHTML = originalHTML;

      // End theme loading
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

    } catch (error) {
      console.error('[Product Card Quick Add] ❌ ERROR:', error);

      // Show error to user
      alert(error.message || 'Failed to add item to cart. Please try again.');

      // Restore button state
      button.disabled = false;
      button.classList.remove('loading');
      button.innerHTML = button.getAttribute('data-original-html') || 'Add to Cart';

      // End theme loading
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

    } finally {
      // Always unlock after delay to prevent rapid clicks
      setTimeout(() => {
        activeRequests.delete(variantId);
      }, 500);
    }
  }

  /**
   * Handle click on quick-add button
   */
  function handleQuickAddClick(event) {
    const button = event.target.closest('.quick-add-btn');

    if (!button) return;

    // Prevent default and stop propagation immediately
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const variantId = button.dataset.variant;

    if (!variantId) {
      console.error('[Product Card Quick Add] ❌ No variant ID on button');
      return;
    }

    // Store original HTML for restoration
    if (!button.hasAttribute('data-original-html')) {
      button.setAttribute('data-original-html', button.innerHTML);
    }

    // Add to cart
    addSingleItemToCart(variantId, button);
  }

  // Attach single event listener with capture phase to intercept early
  document.addEventListener('click', handleQuickAddClick, true);

})();
